const UploadIcon = (props: any) => (
    <svg
        width={44}
        height={44}
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Upload file"
        {...props}
    >
        <g filter="url(#filter0_d_865_3977)">
            <path
                d="M2.5 9C2.5 4.85786 5.85786 1.5 10 1.5H34C38.1421 1.5 41.5 4.85786 41.5 9V33C41.5 37.1421 38.1421 40.5 34 40.5H10C5.85786 40.5 2.5 37.1421 2.5 33V9Z"
                stroke="#EAECF0"
                shapeRendering="crispEdges"
            />
            <path
                d="M18.6667 24.3333L22 21M22 21L25.3333 24.3333M22 21V28.5M28.6667 24.9524C29.6846 24.1117 30.3333 22.8399 30.3333 21.4167C30.3333 18.8854 28.2813 16.8333 25.75 16.8333C25.5679 16.8333 25.3975 16.7383 25.3051 16.5814C24.2184 14.7374 22.212 13.5 19.9167 13.5C16.4649 13.5 13.6667 16.2982 13.6667 19.75C13.6667 21.4718 14.3629 23.0309 15.4891 24.1613"
                stroke="#344054"
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_865_3977"
                x={0}
                y={0}
                width={44}
                height={44}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={1} />
                <feGaussianBlur stdDeviation={1} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_865_3977"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_865_3977"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);

export default UploadIcon;
